import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookingAgentModalService {

  private selectedBookingAgentSubject = new BehaviorSubject<any>(null);
  public selectedBookingAgent$ = this.selectedBookingAgentSubject.asObservable();

  constructor() { }

  setSelectedBookingAgent(bookingAgent: any): void {
    this.selectedBookingAgentSubject.next(bookingAgent);
  }

  getSelectedBookingAgent(): any | null {
    return this.selectedBookingAgentSubject.value;
  }

  clearSelectedBookingAgent(): void {
    this.selectedBookingAgentSubject.next(null);
  }
}

